/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from 'graphql-tag';

export const GET_MY_ORG_PROFILE = gql`
  query Org {
    getMyProfile {
      citizenship
      otherNationality
      occupation
      gender
      maritalStatus
      placeOfBirth
      countryOfBirth
      dateOfBirth
      passportNumber
      passportIssuanceDate
      passportExpiry
      passportType
      skills
      orgRoles {
        orgId {
          orgId
          name
        }
        role {
          name
          uuid
        }
      }
      qualification {
        degree
      }
      natureOfBusiness
      intendedAddress {
        addressLine1
      }
      address {
        addressLine1
        addressLine2
        addressLine3
        city
        state
        parish
        zipcode
        country
      }
      natureOfProfessionalActivity
      noOfYearsWithCompany
      intendedAddress {
        addressLine1
        addressLine2
        addressLine3
        city
        state
        parish
        zipcode
        country
      }
      vuid
      userId
      firstName
      middleName
      lastName
      fullName
      emailVerified
      phoneVerified
      image
      accountStatus
      nationality

      primaryContactNo
      isNameChange
      createdAt
      org {
        reason
        tccNumber
        orgRole
        isOperatingAddressSame
        landlineContactNo
        businessRegistrationExpiryDate
        isBranchExist
        isDirectorExist
        isBussinessRegistered
        setUpApplicationNo
        isSubsidiaryExist
        operatingAddress {
          addressLine1
          addressLine2
          addressLine3
          city
          state
          parish
          zipcode
          country
        }
        status
        country
        address {
          addressLine1
          addressLine2
          addressLine3
          city
          country
          state
          zipcode
          parish
        }
        tccExpiryDate
        description
        email
        logo
        name
        orgId
        primaryContactNo
        socialLinks
        website
        tradingName
        trn
        type
        registrationNo
        natureOfBusiness
        incorporationDate
        directors {
          firstName
          lastName
          middleName
          nationality
          isLastNameExist
          primaryContactNo
          occupation
          email
          isLastNameExist
          orgRoles {
            ifDirectorStatus
            orgId {
              orgId
            }
            directorInvitedOn
          }
        }
        branches {
          name
          address {
            addressLine1
            addressLine2
            city
            country
            parish
            zipcode
            state
          }
          primaryContactNo
          email
          website
          contactPerson
        }
        subsidiaries {
          status
          email
          primaryContactNo
          tradingName
          website
          name
          address {
            addressLine1
            addressLine2
            city
            parish
            state
            country
            zipcode
          }
          contactPerson
        }
        documents {
          type
          src
          name
          fileType
          expiry
        }
      }
      trn
      email
    }
  }
`;
